import { KeyValue } from '@/main/models/common';
import { SubModelRequest } from '@/main/models/request';
import { SubModelActionTypes, SubModelTypes } from './subModelTypes';

export function getSubModels(
  request: SubModelRequest,
  keyReducer: string = 'default'
): SubModelActionTypes {
  return {
    type: SubModelTypes.GET_SUBMODELS,
    payload: { request, keyReducer }
  };
}

export function saveSubModels(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): SubModelActionTypes {
  return {
    type: SubModelTypes.SAVE_SUBMODELS,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerSubModels(
  keyReducer: string = 'default'
): SubModelActionTypes {
  return {
    type: SubModelTypes.RESET_REDUCER_SUBMODELS,
    payload: { keyReducer }
  };
}

